var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "form-group" }, [
    _c("label", [
      _vm.f.IsRequired
        ? _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
        : _vm._e(),
      _vm._v(" " + _vm._s(_vm.f.Name)),
    ]),
    _vm._v(" "),
    _c("textarea", {
      directives: [
        {
          name: "model",
          rawName: "v-model.trim",
          value: _vm.f.Value,
          expression: "f.Value",
          modifiers: { trim: true },
        },
      ],
      staticClass: "form-control",
      attrs: {
        placeholder: "Enter text...",
        rows: _vm.f.Rows,
        required: _vm.f.IsRequired === true,
        readonly: _vm.f.IsReadonly === true,
        minlength: _vm.f.MinLength != null ? _vm.f.MinLength : null,
        maxlength: _vm.f.MaxLength != null ? _vm.f.MaxLength : null,
      },
      domProps: { value: _vm.f.Value },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.$set(_vm.f, "Value", $event.target.value.trim())
        },
        blur: function ($event) {
          return _vm.$forceUpdate()
        },
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))]),
    _vm._v(" "),
    _vm.f.Description
      ? _c("small", { staticClass: "form-text text-muted" }, [
          _vm._v(_vm._s(_vm.f.Description)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }